import {useNavigate, Navigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import Spinner from "../components/Spinner";
import useFetch from "../hooks/useFetch";
import CertificateCard from "../page_components/certificate/certificate_card";
import CertificateTable from "../page_components/certificate/certificate_table";

const Certificates = () => {




    return (
         
                <div className="container-xxl flex-grow-1 container-p-y">
                    <h4 className="py-3 mb-4"><span className="text-muted fw-light">Certificates</span></h4>
                    
                  
                    <CertificateCard/>
                    <CertificateTable/>
                </div>
       
    );
}

export default Certificates;